import React from 'react'
// import styled from 'styled-components'
import { useTable, useSortBy, useFilters, useGlobalFilter, useExpanded, useRowSelect } from 'react-table'
import matchSorter from 'match-sorter'
import {Link} from 'react-router-dom'
// import { history } from '../../_helpers';
// import ReactTable from "react-table";

// import makeData from './makeData'

// import './Table.css'

import {Styles} from './TableStyle'
// import {motion} from 'framer-motion'
// import { withTheme } from '@material-ui/styles'
// import { NONAME } from 'dns'

// const ReactTable = require('react-table');
// let current_id = history.location.pathname.split('/')[3]


function GlobalFilter({
    preGlobalFilteredRows,
    globalFilter,
    setGlobalFilter,
  }) {
    const count = preGlobalFilteredRows.length
  
    return (
      <span style={{width: "100%"}}>
        {/* Search:{' '} */}
        <input
          value={globalFilter || ''}
          onChange={e => {
            setGlobalFilter(e.target.value || undefined) // Set undefined to remove the filter entirely
          }}
          placeholder={`${count} records...`}
          style={{
            fontSize: '1.1rem',
            border: '0',
            width: "100%"
          }}
        />
      </span>
    )
  }

export function DefaultColumnFilter({
    column: { filterValue, preFilteredRows, setFilter },
  }) {
    const count = preFilteredRows.length
  
    return (
      <input
        value={filterValue || ''}
        onChange={e => {
          setFilter(e.target.value || undefined) // Set undefined to remove the filter entirely
        }}
        placeholder={`${count} records...`}
        style={{
            width: "100%",
            // maxWidth: "150px"
          }}
      />
    )
  }

function RealDefaultColumnFilter({
    column: { filterValue, preFilteredRows, setFilter },
  }) {
    // const count = preFilteredRows.length
  
    return (
      <div>-</div>
    )
  }
  
  // This is a custom filter UI for selecting
  // a unique option from a list
export function SelectColumnFilter({
    column: { filterValue, setFilter, preFilteredRows, id },
  }) {
    // Calculate the options for filtering
    // using the preFilteredRows
    const options = React.useMemo(() => {
      const options = new Set()
      preFilteredRows.forEach(row => {
        options.add(row.values[id])
      })
      return [...options.values()]
    }, [id, preFilteredRows])
  
    // Render a multi-select box
    return (
      <select
        value={filterValue}
        onChange={e => {
          setFilter(e.target.value || undefined)
        }}
      >
        <option value="">All</option>
        {options.map((option, i) => {
            // console.log(options)
            return(
                <option key={i} value={option}>
                    {option}
                </option>
            )
        })}
      </select>
    )
  }
  
  // This is a custom filter UI that uses a
  // slider to set the filter value between a column's
  // min and max values

// function SliderColumnFilter({
//     column: { filterValue, setFilter, preFilteredRows, id },
//   }) {
//     const [min, max] = React.useMemo(() => {
//       let min = preFilteredRows.length ? preFilteredRows[0].values[id] : 0
//       let max = preFilteredRows.length ? preFilteredRows[0].values[id] : 0
//       preFilteredRows.forEach(row => {
//         min = Math.min(row.values[id], min)
//         max = Math.max(row.values[id], max)
//       })
//       return [min, max]
//     }, [id, preFilteredRows])
  
//     return (
//       <>
//         <input
//           type="range"
//           min={min}
//           max={max}
//           value={filterValue || min}
//           onChange={e => {
//             setFilter(parseInt(e.target.value, 10))
//           }}
//         />
//         <button onClick={() => setFilter(undefined)}>Off</button>
//       </>
//     )
//   }
  
  // This is a custom UI for our 'between' or number range
  // filter. It uses two number boxes and filters rows to
  // ones that have values between the two

// function NumberRangeColumnFilter({
//     column: { filterValue = [], preFilteredRows, setFilter, id },
//     }) {
//     const [min, max] = React.useMemo(() => {
//       let min = preFilteredRows.length ? preFilteredRows[0].values[id] : 0
//       let max = preFilteredRows.length ? preFilteredRows[0].values[id] : 0
//       preFilteredRows.forEach(row => {
//         min = Math.min(row.values[id], min)
//         max = Math.max(row.values[id], max)
//       })
//       return [min, max]
//     }, [id, preFilteredRows])
  
//     return (
//       <div
//         style={{
//           display: 'flex',
//         }}
//       >
//         <input
//           value={filterValue[0] || ''}
//           type="number"
//           onChange={e => {
//             const val = e.target.value
//             setFilter((old = []) => [val ? parseInt(val, 10) : undefined, old[1]])
//           }}
//           placeholder={`Min (${min})`}
//           style={{
//             width: '70px',
//             marginRight: '0.5rem',
//           }}
//         />
//         to
//         <input
//           value={filterValue[1] || ''}
//           type="number"
//           onChange={e => {
//             const val = e.target.value
//             setFilter((old = []) => [old[0], val ? parseInt(val, 10) : undefined])
//           }}
//           placeholder={`Max (${max})`}
//           style={{
//             width: '70px',
//             marginLeft: '0.5rem',
//           }}
//         />
//       </div>
//     )
//   }
  
function fuzzyTextFilterFn(rows, id, filterValue) {
    return matchSorter(rows, filterValue, { keys: [row => row.values[id]] })
  }
  
  // Let the table remove the filter if the string is empty
  fuzzyTextFilterFn.autoRemove = val => !val


// const IndeterminateCheckbox = React.forwardRef(
// ({ row, indeterminate, ...rest }, ref) => {
    
//     const defaultRef = React.useRef()
//     const resolvedRef = ref || defaultRef

//     // console.log(row)

//     React.useEffect(() => {
//     resolvedRef.current.indeterminate = indeterminate
//     }, [resolvedRef, indeterminate])

//     return (<>
//       <input id={"exc-" + row} type="checkbox" ref={resolvedRef} {...rest} />
//       <label htmlFor={"exc-" + row}></label>
//     </>)
// }
// )
  
export function ColHiding(func, flatColumns){
    return(
        <div id="columns-filter">
            {flatColumns.map((column, index) =>{
                // console.log(column)
                return(
                    <span key={column.id}>
                        {index >=2 ?  
                        <span key={column.id}>
                            {/* <label> */}
                            <input id={"toggle"+column.Header} type="checkbox" {...column.getToggleHiddenProps()} />
                            <label htmlFor={"toggle"+column.Header}>{column.Header} {' '}</label>
                            {/* </label> */}
                        </span>: null}
                    </span>
                    
                )
            })}
            <br />
        </div>
    )
}

// const EditableCell = ({
//   value: initialValue,
//   row: { index },
//   column: { id },
//   updateMyData, // This is a custom function that we supplied to our table instance
// }) => {
//   // We need to keep and update the state of the cell normally
//   const [value, setValue] = React.useState(initialValue)

//   const onChange = e => {
//     setValue(e.target.value)
//   }

//   // We'll only update the external data when the input is blurred
//   const onBlur = () => {
//     updateMyData(index, id, value)
//   }

//   // If the initialValue is changed external, sync it up with our state
//   React.useEffect(() => {
//     setValue(initialValue)
//   }, [initialValue])

//   return <input value={value} onChange={onChange} onBlur={onBlur} />
// }

// Set our editable cell renderer as the default Cell renderer
// const defaultColumn = {
//   Cell: EditableCell,
// }

export function Table({ columns, data, version, windowWidth, dataReset, updateMyData, skipPageReset, currentId  }) {
  // Use the state and functions returned from useTable to build your UI
    
// this.setState({ windowWidth, windowHeight });
    // console.log("Table version: " + version)
  

  // console.log(columns, data)
  const filterTypes = React.useMemo(
    () => ({
      // Add a new fuzzyTextFilterFn filter type.
      fuzzyText: fuzzyTextFilterFn,
      // Or, override the default text filter to use
      // "startWith"
      text: (rows, id, filterValue) => {
        return rows.filter(row => {
          const rowValue = row.values[id]
          return rowValue !== undefined
            ? String(rowValue)
                .toLowerCase()
                .startsWith(String(filterValue).toLowerCase())
            : true
        })
      },
    }),
    []
  )

  const defaultColumn = React.useMemo(
    () => ({
      // Let's set up our default Filter UI
      Filter: RealDefaultColumnFilter,
      // Cell: EditableCell,
    }),
    []
  )

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    state,
    flatColumns,
    preGlobalFilteredRows,
    setGlobalFilter,
    // getToggleHideAllColumnsProps,
    // selectedFlatRows,
    // getToggleRowSelectedProps,
    // state: {expanded, selectedRowIds}
  } = useTable({
        columns,
        data,
        filterTypes,
        defaultColumn, // Be sure to pass the defaultColumn option
        
        autoResetPage: !skipPageReset,
        updateMyData,
    },
    
    useFilters, // useFilters!
    useGlobalFilter, // useGlobalFilter!
    useSortBy,
    useExpanded,
    useRowSelect,
    // hooks => {
    //     hooks.flatColumns.push(columns => [
    //         // Let's make a column for selection
    //         {
    //           id: 'selection',
    //           // The header can use the table's getToggleAllRowsSelectedProps method
    //           // to render a checkbox
    //           Header: ({ getToggleAllRowsSelectedProps }) => (
    //             <div>
    //               {/* <IndeterminateCheckbox {...getToggleAllRowsSelectedProps()} /> */}
    //             </div>
    //           ),
    //           // The cell can use the individual row's getToggleRowSelectedProps method
    //           // to the render a checkbox
    //           Cell: ({ row }) => (
    //             <div>
    //               {/* {console.log(selectedFlatRows.length)} */}
    //               <div></div>
    //               <IndeterminateCheckbox row={row.id} {...row.getToggleRowSelectedProps()} />
    //             </div>
    //           ),
    //         },
    //         ...columns,
    //       ])
    // }
  )
//   console.log(version)
//   console.log(data)

// console.log(flatColumns)
// console.log(selectedFlatRows.map(d => d.id))

  // Render the UI for your table
  return (
      <>
        {/* <button id={'transfer-Btn'}
            style={selectedFlatRows.length >=1 ? {opacity: '1'} : {opacity: '.5', cursor: 'not-allowed', }}
            onClick={()=> {
                if (selectedFlatRows.length >=1) 
                    if (window.confirm(selectedFlatRows.map(d => d.original["taskUUID"]) + ' 진짜 옮길거?'))
                        _versionAllSwitch(
                            selectedFlatRows.map(d => d.original["taskUUID"]), 
                            version,
                            dataReset)
                        }}>
                {version? 'Checked data to WJ' : 'Checked data to DEV'}
        </button> */}

        {/* {ColHiding(getToggleHideAllColumnsProps(), flatColumns)} */}
        
        <div id={"table-div"}>
          <div id ={"table-input"}>
            <GlobalFilter
                preGlobalFilteredRows={preGlobalFilteredRows}
                globalFilter={state.globalFilter}
                setGlobalFilter={setGlobalFilter}
            />
          </div>
        <table {...getTableProps()}>
        <thead>
            
            {/* {console.log(headerGroups)} */}

            {headerGroups.map((headerGroup, index) => {
                // if (index === 1){
                    return(
                        <tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column, index) => {
                              // console.log(column)
                                // if (index >= 2){
                                // return(
                                // <th {...column.getHeaderProps()}>
                                //     <div>{column.canFilter || column.render('Filter')? column.render('Filter') : null}</div>
                                // </th>  
                                // )       
                                // }
                                // else{
                                    return(
                                      <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                                        {column.render('Header')}
                                        {/* Add a sort direction indicator */}
                                        <span>
                                          {column.isSorted
                                            ? column.isSortedDesc
                                              ? ' ↓'
                                              : ' ↑'
                                            : ''}
                                        </span>
                                      </th>
                                    )
                                // }
                            }
                            )}
                        </tr>
                    )
                // }
            })}

            <tr>
                <th colSpan="1" style={{border: 'none',}}></th>
                {/* <th colSpan="1"></th> */}
                <th
                colSpan={flatColumns.length-3}
                style={{
                  border: 'none',
                }}
                >
                {/* <GlobalFilter
                  preGlobalFilteredRows={preGlobalFilteredRows}
                  globalFilter={state.globalFilter}
                  setGlobalFilter={setGlobalFilter}
              /> */}
                </th>
            </tr>
        </thead>
        

        <tbody {...getTableBodyProps()}>
            {rows.map((row, i) => {
                prepareRow(row);
                return (
                    <React.Fragment {...row.getRowProps()}>
                        <tr 
                        // style={
                        //   // {backgroundColor: 'white'}
                        //   selectedFlatRows.map(d => d.id).includes(String(row.id)) ?
                        //   {backgroundColor: "rgba(255, 255, 255, .3)", zIndex: '-5', transition: '.2s'} 
                        //   : {backgroundColor: "transparent",transition: '.2s'} }
                          >

                        {row.cells.map((cell, index) => {
                            // console.log(cell.value)
                            // console.log(row.cells)
                            // console.log(index)
                            if(index !== 4)
                            return (
                              <td 
                                {...cell.getCellProps()}> 
                                <Link to={'/recruiter/search/' + row.cells[0].value + '/' + row.cells[6].value + '/' + currentId}
                                ></Link>
                                {cell.render('Cell')} 
                              </td>
                            )
                            else
                              return (
                                <td 
                                  {...cell.getCellProps()}> 
                                  {/* <Link to={'/recruiter/search/' + row.cells[0].value + '/' + row.cells[6].value + '/' + currentId}
                                  ></Link> */}
                                  {cell.render('Cell')} 
                                </td>
                              )
                        })}
                        </tr>
                        {/*
                            If the row is in an expanded state, render a row with a
                            column that fills the entire length of the table.
                        */}
                        {/* {row.isExpanded ? (
                        <tr>
                            <td id={'expandedTd'} colSpan={flatColumns.length}>
                                <div>
                            
                                    <span>{data[row['id']]['download']}</span>
                                    <span>{data[row['id']]['run']}</span>
                                    <span>{data[row['id']]['view']}</span>
                                    <span>{data[row['id']]['pdf']}</span>
                                    <span>{data[row['id']]['versionSwitch']}</span>
                                </div>
                            </td>
                        </tr>
                        ) : 
                        <tr>
                        </tr>} */}
                    </React.Fragment>
                )}
            )}
        </tbody>
        </table>
        </div>
        {/* <p>Selected Rows: {Object.keys(selectedRowIds).length}</p> */}
        
    </>
  )
}



export function TableApp(props) {
    // console.log(tableData)
    // console.log(versionBool)
    let windowWidth = typeof window !== "undefined" ? window.innerWidth : 0;
    // let windowHeight = typeof window !== "undefined" ? window.innerHeight : 0;



    if(windowWidth >= 768){
    }
    else{
    }

    
    // const columns = React.useMemo(
    // () => 
    //     [
    //         {
    //             Header: ' ',
    //             columns: props.columns
    //         },
    //     ],
    // )
    
  // const newData = React.useMemo(() => props.data)
  const [data, setData] = React.useState(()=> props.data)
  // const [originalData] = React.useState(data)
  const [skipPageReset, setSkipPageReset] = React.useState(false)

  // const updateMyData = (rowIndex, columnId, value) => {
  //   setSkipPageReset(true)
  //   setData(old =>
  //     old.map((row, index) => {
  //       if (index === rowIndex) {
  //         return {
  //           ...old[rowIndex],
  //           [columnId]: value,
  //         }
  //       }
  //       return row
  //     })
  //   )
  // }

  React.useEffect(() => {
    setSkipPageReset(false)
  }, [data])

  // const resetData = () => setData(originalData)

  console.log(data)

  return (
      
    // <Styles className={props ? "visible" : "hidden"}>
    <Styles>
      <div>
        <Table  
            columns={props.columns} 
            data={props.data} 
            version={props.versionBool} 
            windowWidth={windowWidth}
            dataReset={props.dataReset}
            // renderRowSubComponent={renderRowSubComponent}
            // updateMyData={updateMyData}
            skipPageReset={skipPageReset}
            currentId = {props.currentId}
        />
        </div>
        <Link to ='/' params={{say: 'hello'}}></Link>
    </Styles>
  )
}

// export default TestApp